import { inject } from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from '@angular/router';
import {UserEventsService} from '@services';
import {take, of, EMPTY} from 'rxjs';
import {UserEvent} from "@model";
import {mergeMap} from "rxjs/operators";
import {MY_TRACEY} from "../app-routing.module";

export const MyEntryDetailsResolver: ResolveFn<UserEvent | undefined> =
    (route: ActivatedRouteSnapshot,
     state: RouterStateSnapshot,
     userEventsService: UserEventsService = inject(UserEventsService),
     router: Router = inject(Router)) => {
  const competitorId: number | undefined = +route.queryParams['competitorId'] ? +route.queryParams['competitorId'] : undefined;
  if (competitorId) {
    return userEventsService.fetchEntryData(competitorId).pipe(
        take(1),
        mergeMap((res: UserEvent | undefined) => {
          if (res) {
            return of(res);
          } else {
            router.navigate([MY_TRACEY]);
            return EMPTY;
          }
        })
    );
  } else {
    router.navigate([MY_TRACEY]);
    return EMPTY;
  }
};
